module.exports = __webpack_public_path__ + "static/pic05-be90555d2c47ed1564bd0527efa65fed.jpg";